import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Heading, Stack, Text, HStack, Button, Icon } from "@chakra-ui/react";

import { RoutesMap } from "../../../../routes.tsx";
import { CircleWithExclamationMarkIcon } from "../../../icons";
import { useRefuseLoanMutation } from "../../../../api/cooling";

interface Props {
  hideModal: () => void;
  blockModalClosing: (state: boolean) => void;
}

export const CoolingPageModal: FC<Props> = ({ hideModal, blockModalClosing }) => {
  const navigate = useNavigate();
  const { mutateAsync, isPending, isError } = useRefuseLoanMutation();

  const onHomeClick = () => {
    if (!isPending) {
      hideModal();
      navigate(RoutesMap.index);
    }
  };

  const confirmRefusal = async () => {
    blockModalClosing(true);

    try {
      await mutateAsync();
      hideModal();
      navigate(RoutesMap.index);
    } catch {
      // isError will be triggered
    } finally {
      blockModalClosing(false);
    }
  };

  return (
    <Stack spacing="6px" px="5px">
      <Heading fontSize="20px" mb={isError ? "6px" : "68px"}>
        После отказа от выдачи займа подписанный договор будет аннулирован
      </Heading>

      {isError && (
        <HStack spacing="3px" mb="20px">
          <Icon as={CircleWithExclamationMarkIcon} boxSize="24px" />
          <Text variant="red" lineHeight="18px">
            Произошла ошибка при обработке вашего запроса. Заём пока не аннулирован
          </Text>
        </HStack>
      )}

      <Button onClick={onHomeClick} colorScheme="brand">Не отказываться</Button>
      <Button onClick={confirmRefusal} isLoading={isPending}>Подтвердить отказ</Button>
    </Stack>
  );
};
